module.exports = __webpack_public_path__ + "f0b8fff952e82f1a66963d0fd891855c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/home_bg.jpg
// module id = 654
// module chunks = 0